import { render } from "./AppBadge.vue?vue&type=template&id=5a30d81a&ts=true"
import script from "./AppBadge.vue?vue&type=script&lang=ts"
export * from "./AppBadge.vue?vue&type=script&lang=ts"

import "./AppBadge.vue?vue&type=style&index=0&id=5a30d81a&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__